import { createErrorListFromUnknownError, _Error } from "@/lib/wordpress/data";
import { Either, mapLeft } from "fp-ts/lib/Either";
import { Json, parse } from "fp-ts/Json";
import { pipe } from "fp-ts/lib/function";

function fpJsonParse(jsonWhichMightBeInvalid: string): Either<_Error[], Json> {
  return pipe(
    jsonWhichMightBeInvalid,
    parse,
    mapLeft(e =>
      createErrorListFromUnknownError(e, "Failed to parse given JSON")
    )
  );
}

export default fpJsonParse;
